import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { FC } from 'react';
import MiViewTooltip from '../MiViewTooltip/MiViewTooltip';
import useMiViewMenu from './MiViewMenu.hook';
import { menuItemStyle, iconStyle, menuItemElementStyle } from './MiViewMenu.style';
import { MiViewMenuProps } from './MiViewMenu.types';

const MiViewTacticCard: FC<MiViewMenuProps> = ({ menuList, children, buttonStyle, tooltipMessage }) => {
  const { handleClick,
    handleClose,
    handleAction,
    open,
    anchorEl } = useMiViewMenu();

  return (
    <div>
      <Button
        id="menu-button"
        aria-controls={ open ? 'positioned-menu' : undefined }
        aria-haspopup="true"
        aria-expanded={ open ? 'true' : undefined }
        onClick={ handleClick }
        TouchRippleProps={ { style: { color: 'rgba(0, 0, 0, 0.15)' } } }
        sx={ buttonStyle }
      >
        { children }
      </Button>
      <Menu
        id="positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={ anchorEl }
        open={ open }
        onClose={ handleClose }
        anchorOrigin={
          {
            vertical: 'bottom',
            horizontal: 'right',
          }
        }
        transformOrigin={
          {
            vertical: 'top',
            horizontal: 'right',
          }
        }
      >
        {
          menuList && menuList.map((menuItem) => {
            const Icon = menuItem.icon;

            const content = (
              <>
                { menuItem.label }
                { Icon && <Icon sx={ iconStyle } /> }
              </>
            );

            return (
              <MenuItem
                key={ menuItem.label }
                sx={ menuItemStyle }
                onClick={ () => handleAction(menuItem.clickAction) }
              >
                {
                  tooltipMessage ? (
                    <MiViewTooltip title={ tooltipMessage } followCursor>
                      <Box sx={ menuItemElementStyle }>
                        { content }
                      </Box>
                    </MiViewTooltip>
                  ) : (
                    content
                  )
                }
              </MenuItem>
            );
          })
        }

      </Menu>
    </div>
  );
};

export default MiViewTacticCard;
